import React from 'react';
import { Accordion } from '../Accordion';
import { Badge } from '../Badge';
const FAQ_ITEMS = [{
  id: 'skill',
  title: 'ITの知識がなくても使えますか？',
  content: 'はい、まったく問題ありません。設定や準備はすべてこちらで対応し、導入後の操作もシンプルです。むずかしいことは専門家にすべておまかせください。'
}, {
  id: 'cost',
  title: '費用はどのくらいかかりますか？',
  content: '高額な初期投資は必要ありません。月額数万円〜となります。ご利用状況に応じた費用感については、お問い合わせください。'
}, {
  id: 'speed',
  title: '導入までどのくらいかかりますか？',
  content: '内容にもよりますが、最短で翌日からご利用いただけます。お急ぎの場合も、まずはご相談ください。'
}, {
  id: 'support',
  title: '導入したあとのサポートはありますか？',
  content: 'もちろんです。導入して終わりではなく、運用中の疑問や調整にも継続して対応します。困ったときに相談できる「伴走するパートナー」であり続けます。'
}, {
  id: 'onsite',
  title: 'サポートは会社に来てやってくれるのですか？',
  content: <>
        スピードと低価格を両立するため、基本的なサポートは以下の方法を中心に行っています。
        <br data-id="element-186" data-mp="1se1l1c2qyqq6" />
        <br data-id="element-187" data-mp="1sdi3vxkx86d7" />
        ・お電話・オンライン（画面共有）
        <br data-id="element-188" data-mp="1sgntrf1djc9z" />
        ・お客様専用ポータル（24時間受付）
        <br data-id="element-189" data-mp="1nfzrfx7p390g" />
        <br data-id="element-190" data-mp="1ng9ilo4h7m7q" />
        訪問コストを徹底的にカットすることで「初期費用ゼロ」を実現しています。もちろん、横須賀地域のパートナーですので、必要な際には対面でも柔軟に伴走いたします。
      </>
}, {
  id: 'quit',
  title: '合わなかった場合、やめることはできますか？',
  content: 'ご利用状況に応じた対応をご案内します。ご不安な点は、まずお問い合わせください。'
}, {
  id: 'phone-number',
  title: '今使っているお店の電話番号はそのまま使えますか？',
  content: 'はい、現在お店でお使いの電話番号をそのままご利用いただけます。'
}, {
  id: 'complex-questions',
  title: 'AIが答えられない複雑な質問をされたらどうなりますか？',
  content: 'すぐに「担当者からの折り返し」へと丁寧にご案内します。AIが判断できないご相談や「スタッフと直接話したい」というご要望があった場合は、AIがお客様のご用件とご連絡先をお伺いした上で「担当者から折り返しご連絡いたします」と丁寧に対応を完了させます。その後、即座にあなたのスマホへ内容を通知しますので、お客様にご迷惑をおかけすることはありません。'
}, {
  id: 'busy-line',
  title: '予約の電話が重なった場合、「話し中」になってしまいませんか？',
  content: 'いいえ、AI受付スタッフは「話し中」になることがありません。同時に複数のお客様からお電話がかかってきても、全員に同時に対応し、お待たせすることなくご案内や予約の受付を行います。繁忙期や朝一番の電話ラッシュ時でも、お客様の取りこぼし（機会損失）は完全にゼロになります。'
}];
export function FaqSection() {
  return <section id="faq" className="w-full scroll-mt-24 bg-surface-muted" data-id="element-191" data-mp="3ch2vn8ua5zqo">
      <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-24" data-id="element-192" data-mp="3gj7pa7kqawdb">
        <div className="text-center" data-id="element-193" data-mp="3ghd54vha78aa">
          <Badge variant="navy" data-id="element-194" data-mp="noh8ddnmo49c">よくある質問</Badge>
          <h2 className="mt-4 text-2xl font-bold text-text sm:text-3xl" data-id="element-195" data-mp="nn665i9tz4kc">
            はじめる前の、不安にお答えします
          </h2>
        </div>

        <div className="mt-10" data-id="element-196" data-mp="xesri7fvuk0t">
          <Accordion items={FAQ_ITEMS} defaultOpenIds={['skill']} data-id="element-197" data-mp="xe0tyr2q6c7w" />
        </div>
      </div>
    </section>;
}